<form class="d-flex align-items-center justify-content-end">
    <input class="form-control me-2" type="search" name="pesquisa" placeholder="Pesquisar" aria-label="Pesquisar"  [(ngModel)]="palavrachave" (change)="procurar()" >
  
    <ul class="navbar-menu">
        <li>
          <a href="{{getRedeSocialLink('Facebook')}}" target="_blank">
            <img src="./assets/icons/icons-facebook.svg" alt="icone do facebook" class="mx-1">
          </a>
        </li>
        <li>
          <a href="{{getRedeSocialLink('Instagram')}}" target="_blank">
            <img src="./assets/icons/icons-insta.svg" alt="icone do instagram" class="mx-1">
          </a>
        </li>
        <li>
          <a href="{{getRedeSocialLink('Linkedin')}}" target="_blank">
            <img src="./assets/icons/icons-linkedin.svg" alt="icone do linkedin" class="mx-1">
          </a>
        </li>
        <li>
          <a href="{{getRedeSocialLink('Twitter')}}" target="_blank">
            <img src="./assets/icons/icons-twitter.svg" alt="icone do twitter" class="mx-1">
          </a>
        </li>
        <li>
          <a href="{{getRedeSocialLink('Youtube')}}" target="_blank">
            <img src="./assets/icons/icons-youtube.svg" alt="icone do youtube" class="mx-1">
          </a>
        </li>
      </ul>
  </form>
